import {post, put} from "../util/http.service";

export const createBudgetCategory = (budgetId, category) => post("/budgets/" + budgetId + "/categories", category);

export const updateBudgetCategory = (budgetId, catId, category) => put("/budgets/" + budgetId + "/categories/" + catId, category);
